import axios from "axios"
import { API, baseUrl } from "./api"

export const login=async (data)=>{
    return await axios.post(baseUrl+API.login,data)
}


